import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { Mail } from 'lucide-react';
import { useAuth } from '@/hooks/useAuth';

const SubscriptionError: React.FC = () => {
  const navigate = useNavigate();
  const { userProfile } = useAuth();
  
  // Vérifier si l'utilisateur est en freemium (niveau_compte_id = 1)
  const isFreemium = userProfile?.niveau_compte_id === 1;
  
  const handleRetry = () => {
    // Rediriger vers la page d'accueil plutôt que de simplement rafraîchir
    // pour éviter une boucle potentielle
    navigate('/');
  };
  
  const handleContactSupport = () => {
    window.location.href = 'mailto:contact@zan.estate?subject=Problème%20avec%20mon%20abonnement';
  };
  
  const handleViewPlans = () => {
    navigate('/subscription-change/new');
  };
  
  const handleViewWebsite = () => {
    window.open('https://zan.estate/', '_blank');
  };
  
  if (isFreemium) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="text-xl">Compte Freemium</CardTitle>
          <CardDescription>Profitez des avantages premium</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">
            Vous utilisez actuellement le plan gratuit. Pour accéder à toutes les fonctionnalités et outils avancés,
            passez à un plan premium adapté à vos besoins.
          </p>
        </CardContent>
        <CardFooter className="flex flex-col space-y-2 sm:flex-row sm:space-y-0 sm:space-x-2">
          <Button variant="outline" onClick={handleViewWebsite}>
            Découvrir les avantages premium
          </Button>
          <Button onClick={handleViewPlans}>
            Voir les plans disponibles
          </Button>
        </CardFooter>
      </Card>
    );
  }
  
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-xl">Votre abonnement</CardTitle>
        <CardDescription>Une erreur est survenue</CardDescription>
      </CardHeader>
      <CardContent>
        <p className="text-sm text-muted-foreground">
          Impossible de récupérer les informations de votre abonnement. Veuillez réessayer plus tard.
        </p>
      </CardContent>
      <CardFooter className="flex flex-col space-y-2 sm:flex-row sm:space-y-0 sm:space-x-2">
        <Button variant="outline" onClick={handleRetry}>
          Réessayer
        </Button>
        <Button variant="secondary" onClick={handleContactSupport} className="flex items-center gap-1">
          <Mail className="h-4 w-4" /> Contacter le support
        </Button>
      </CardFooter>
    </Card>
  );
};

export default SubscriptionError;
